import { Typography } from "@packages/ds";
import styled, { css as styledCSS } from "styled-components";

import * as Table from "ds/Table";
import { breakpoints } from "Libs/theme";

export const Layout = styled.div`
  padding-top: 24px;
  padding-bottom: 32px;
  min-height: 1px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const responsiveColumnLabel = styledCSS`
  flex-basis: 100%;

  @media (min-width: 600px) {
    flex-basis: 35%;
  }

  @media (min-width: ${breakpoints[1]}) {
    flex-basis: 40%;
  }
  @media (min-width: ${breakpoints[2]}) {
    flex-basis: 60%;
  }

`;

export const TeamLabelTd = styled(Table.Td)`
  display: flex;
  justify-content: space-between;
  ${responsiveColumnLabel};
`;

export const TeamLabelTh = styled(Table.Th)`
  ${responsiveColumnLabel};
`;

const responsiveColumnPermissions = styledCSS`
display: none;
  @media (min-width: 600px) {
    display: flex;
    flex-basis: 65%;
  }

  @media (min-width: ${breakpoints[1]}) {
    flex-basis: 60%;
  }

  @media (min-width: ${breakpoints[2]}) {
    flex-basis: 40%;
  }
`;

export const TeamPermissionsTd = styled(Table.Td)`
  ${responsiveColumnPermissions};
`;

export const TeamPermissionsTh = styled(Table.Th)`
  ${responsiveColumnPermissions};
`;

export const Permission = styled.div`
  width: calc(100% / 3);
  display: flex;
  flex-direction: column;
`;

export const TeamMetadataPreview = styled.div`
  gap: 24px;
  padding-left: 24px;
  padding-right: 24px;

  display: none;

  @media (min-width: ${breakpoints[2]}) {
    display: flex;
    align-items: center;
  }
`;

export const ProjectCount = styled(Typography.Label)`
  min-width: 74px;
  white-space: nowrap;
`;
